export default {"src":"/_next/static/media/Menopause and Hormonal Imbalances.70bbf225.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};